import React, { useState } from "react";
import apiClient from "../services/apiClient";
import { useTranslation } from 'react-i18next';

const EndingSuggestionPage = () => {
  const [content, setContent] = useState("");
  const [ending, setEnding] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSuggestEnding = () => {
    if (!content.trim()) {
      alert(t('pleaseEnterContent'));
      return;
    }

    setLoading(true);
    apiClient
      .post("api/v1/stories/suggest_ending", { content })
      .then((response) => setEnding(response.data?.ending))
      .catch((error) => console.error("Error suggesting ending:", error))
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <h1>{t('aiStoryEndingSuggestion')}</h1>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={t('enterCurrentStoryContent')}
        className="w-full p-2 border rounded mb-4"
        rows="10"
      ></textarea>
      <button
        onClick={handleSuggestEnding}
        className="px-4 py-2 bg-blue-500 text-white rounded"
      >
        {t('suggestEnding')}
      </button>
      {loading && <p>{t('loading')}</p>}
      {ending && (
        <div className="mt-4">
          <h2>{t('suggestedEnding')}</h2>
          <p>{ending}</p>
        </div>
      )}
    </div>
  );
};

export default EndingSuggestionPage;